import React, { useState } from "react";
import "./payment-card.scss";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { Link } from "react-router-dom";

const PaymentCard = () => {
  const [selectedCard, setSelectedCard] = useState(0);

  const cards = [
    {
      id: 0,
      logo: "/images/icons/visa-icon.svg",
      masked: "**** **** **** 1234",
      cvv: "123",
      expiry: "12/1997",
    },
    {
      id: 1,
      logo: "/images/icons/dinners.svg",
      masked: "**** **** 1234",
      cvv: "123",
      expiry: "12/1997",
    },
    {
      id: 2,
      logo: "/images/icons/mastercard-icon.svg",
      masked: "**** **** **** 1234",
      cvv: "123",
      expiry: "12/1997",
    },
  ];
  return (
    <section className="payments-page-section">
      <div className="payment-tabs-wrapper">
        <ul className="nav nav-tabs payment-tabs">
          <li className="nav-item" role="presentation">
            <Link to="/payments" className="nav-link active">
              {" "}
              Payments
            </Link>
          </li>
          <li className="nav-item" role="presentation">
            <Link to="/payment-history" className="nav-link">
              {" "}
              Payment History
            </Link>
          </li>
        </ul>

        <div className="tab-content" id="paymentTabsContent">
          <h5 className="form-title">Payment Method</h5>

          <div className="payment-form">
            <div className="payment-options">
              <div className="payment-option active">
                <img src="/images/icons/card-pay.svg" alt="Card" />
                <span className="label">Card</span>
              </div>
              <div className="payment-option">
                <img src="/images/icons/g-pay.svg" alt="Google Pay" />
                <span className="label">Google Pay</span>
              </div>
              <div className="payment-option">
                <img src="/images/icons/app-pay.svg" alt="Apple Pay" />
                <span className="label">Apple Pay</span>
              </div>
              <div className="dropdown">
                <button
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <BiDotsVerticalRounded size={24} />
                </button>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="dropdownMenuButton"
                >
                  <li>
                    <a className="dropdown-item" href="/">
                      Add
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/">
                      Remove as default
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="input-wrap">
                  <label htmlFor="">Card Number</label>
                  <input type="text" placeholder="Card number" />
                </div>
              </div>
              <div className="col-6 pe-md-2 pe-1">
                <div className="input-wrap">
                  <label htmlFor="">Expiration</label>
                  <input type="text" placeholder="MM/YY" />
                </div>
              </div>
              <div className="col-6 ps-1">
                <div className="input-wrap cvc-group">
                  <label htmlFor="">CVC</label>
                  <input type="text" placeholder="CVC" />
                  <img src="/images/icons/cvc.svg" alt="CVC" />
                </div>
              </div>
            </div>

            <button className="submit-btn">Done</button>
          </div>
        </div>
      </div>
      <div className="payment-tabs-wrapper">
        <h5 className="form-title">Cards</h5>
        <div className="payment-cards">
          {cards.map((card) => (
            <div
              key={card.id}
              className={`card-option ${
                selectedCard === card.id ? "selected" : ""
              }`}
              onClick={() => setSelectedCard(card.id)}
            >
              <div className="card-image">
                <img
                  src={card.logo}
                  alt={card.brand}
                  className="brand-logo me-2"
                />
                <span>{card.masked}</span>
              </div>
              <div className="pay-card-row">
                <span>{card.cvv}</span>
                <span>{card.expiry}</span>
                <div className="badge">Defaults</div>
                <div className="dropdown">
                  <button
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <BiDotsVerticalRounded size={24} />
                  </button>
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <li>
                      <a className="dropdown-item" href="/">
                        Delete
                      </a>
                    </li>
                    <li>
                      <span
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#removeCardModal"
                      >
                        Remove as default
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        className="modal fade"
        id="removeCardModal"
        tabIndex="-1"
        aria-labelledby="removeCardModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content removepayment-modal">
            <div className="modal-body">
              <div className="d-flex">
                <div className="flex-shrink-0">
                  <img
                    src="/images/icons/remove-payment.svg"
                    alt="remove payment"
                  />{" "}
                </div>
                <div className="flex-grow-1 ms-3">
                  <h5 className="modal-title">Remove Payment Method?</h5>
                  <p>
                    Are you sure you want to remove this card ending in ••••
                    4242? You won’t be able to use it for future bookings unless
                    added again.
                  </p>{" "}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </button>
              <button type="button" className="btn">
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentCard;
